// /**
//  * Orders - list
//  */

// React
import React, { useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import HeaderBuilder from "../../utils/headerBuilder";

// Context
import AuthContext from "../../authContext";
import orderRepository from "client-sdk/src/Repository/orders-repository";
// UI
import theme from "../../theme";
import clsx from "clsx";
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
  lighten,
} from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Select,
  CircularProgress,
  Grid,
  Divider,
} from "@material-ui/core";

// Icon
import Icon from "@mdi/react";
import {
  mdiClose,
  mdiFileDocumentOutline,
  mdiPackageVariantClosed,
  mdiPencilOutline,
  mdiAccountArrowLeftOutline,
  mdiInformation,
} from "@mdi/js";

// Components
import Can from "../../components/Can";

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from "../../utils/rulesOrderStatus";

// Helper
import { translate, checkMatchMedia } from "../../utils/helpers";
import jMoment from "moment-jalaali";

// Type
import { Order, Status } from "./interfaces";
import List from "./usersList";
import stableSort from "../../utils/Table/stableSort";
import getComparator from "../../utils/Table/getComparator";
import showDeliveryType from "../../utils/temporaryConditions/showDeliveryType";
import showOrderTplType from "../../utils/temporaryConditions/showOrderTplType";
import RonadTableHead from "../../components/TableHeader";
import RonadIcons from "../../components/iconComponent";
import handleNotification from "../../utils/handleNotification";
import handleError from "../../utils/handleError";

type Data = Order;
type Props = {
  data: any;
  users: object;
  loading: boolean;
  handleConfirmCanceleBox: (id: number) => void;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
};
type Ord = "asc" | "desc";

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    body: {
      padding: "10px 0",
      fontSize: 14,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  })
)(TableCell);
const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    paper: {
      width: "100%",
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: "0 10px",
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 650,
      borderRadius: "4px",
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        width: "1px",
        height: "36px",
        top: "4px",
        left: "-9px",
        backgroundColor: "#EDF1F4",
      },
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
  })
);

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: "space-between",
    },
    highlight:
      theme.palette.type === "light"
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
    title: {
      // flex: '1 1 100%',
    },
  })
);

interface EnhancedTableToolbarProps {
  numSelected: number;
  setOpenChangeStatus: any;
  selected: any;
  data: any;
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const classes = useToolbarStyles();
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const { numSelected, selected, data } = props;

  const handleClickChangeStatus = () => {
    const selectedData = data.filter(
      (item: any) => selected.indexOf(item.id) > -1
    );

    if (!checkStatus(selectedData)) {
      setOpenAlertWarning(true);
    } else {
      props.setOpenChangeStatus(true);
    }
  };

  const handleClickChangeStatusWithAggregate = () => {
    const selectedData = data.filter(
      (item: any) => selected.indexOf(item.id) > -1
    );

    if (!checkStatus(selectedData)) {
      setOpenAlertWarning(true);
    } else {
      props.setOpenAggregate();
    }
  };

  const checkStatus = (data: any) => {
    let sameStatus = true;
    data?.map((item: any) => {
      if (item?.status !== data[0]?.status) {
        return (sameStatus = false);
      }
      return item;
    });
    return sameStatus;
  };

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              <span style={{ marginLeft: "10px" }}>{numSelected}</span>
              <span>{"انتخاب"}</span>
            </Typography>
          ) : (
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            />
          )}
          {numSelected > 0 ? (
            <Grid container spacing={2} justify="flex-end">
              <Tooltip style={{ marginLeft: "10px" }} title="تخصیص اپراتور">
                <Button
                  size="small"
                  variant="contained"
                  onClick={handleClickChangeStatusWithAggregate}
                  color="secondary"
                >
                  تخصیص و چاپ
                </Button>
              </Tooltip>
              <Tooltip style={{ marginLeft: "10px" }} title="تخصیص اپراتور">
                <Button
                  size="small"
                  variant="contained"
                  onClick={handleClickChangeStatus}
                  color="secondary"
                >
                  تخصیص اپراتور
                </Button>
              </Tooltip>
              <Link
                style={{ textDecoration: "none" }}
                to={{ pathname: `/orders/receipt/bulk?ids=${selected.join()}` }}
                target="_blank"
              >
                <Tooltip style={{ marginLeft: "10px" }} title="چاپ سفارش ها">
                  <Button size="small" variant="contained" color="secondary">
                    چاپ سفارش ها
                  </Button>
                </Tooltip>
              </Link>
            </Grid>
          ) : (
            <></>
            // <Tooltip title="Filter list">
            //   <IconButton aria-label="filter list">
            //     FilterIcon
            //   </IconButton>
            // </Tooltip>
          )}
        </Toolbar>
      )}
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => setOpenAlertWarning(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد </DialogTitle>
        <DialogContent>
          وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {"متوجه شدم"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const headCells = [
  { id: "id", label: "شناسه سفارش", type: "input" },
  { id: "partnerName", label: "شرکت", type: "input" },
  {
    id: "customerName",
    label: "سفارش‌دهنده",
    type: "input",
  },
  {
    id: "customerCity",
    label: "شهر",
    type: "input",
  },
  {
    id: "deliveryDate",
    label: "تاریخ تحویل",
    type: "date-picker",
  },
  {
    type: "checkbox",
    id: "deliveryType",
    label: "نوع پردازش",
    data: ["COURIER", "POST", "EXPRESS_POST", "SPECIAL_POST", "VIP", "VVIP"],
    translateType: "SendDeliveryType",
  },
  { id: "trackingCode", label: "کد پیگیری", type: "input" },
  {
    type: "checkbox",
    id: "fulfillmentLine",
    label: "مرکز پردازش",
    data: ["COD", "ONLINE"],
    translateType: "COD",
  },
  { id: "itemsCount", label: "تعداد آیتم ها", type: "input" },
  { id: "deadlineProcessTime", label: "مهلت پردازش", type: "input" },
  // { id: "deadlineProcessTime", label: "ساعت مهلت پردازش", type: "input" },
  {
    type: "checkbox",
    id: "status",
    label: "وضعیت",
    data: [
      "ORDERED",
      "DELIVERED_TO_POST",
      "ASSIGNED",
      "PICKED",
      "PACKAGED",
      "BUNDLED",
      "LOADED",
      "ARRIVED",
      "DELIVERED",
      "NOT_DELIVERED",
      "RETURNED",
      "SUPPLYING",
      "CANCELLED",
    ],
    translateType: "Order",
  },
];

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const [aggregate, setAggregate] = useState(false);
  const [order, setOrder] = React.useState<Ord>("desc");
  const [orderBy, setOrderBy] = React.useState<string | number | symbol>("id");
  const [selected, setSelected] = React.useState<string[]>([]);
  const [openChangeStatus, setOpenChangeStatus] = React.useState(false);
  const [selectedOperator, setSelectedOperator] = useState(0);
  const { handleConfirmCanceleBox: handleClickOpen } = props;

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: string | number | symbol
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectOperator = (event: { target: HTMLInputElement }) => {
    const { target } = event;
    setSelectedOperator(+target.value);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.data.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const handleClick = (event: React.MouseEvent<unknown>, id: string) => {
    console.log(order, orderBy);
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const changeStatusOrder = () => {
    props.changeStatusOrderWhitId({
      ids: selected,
      operatorId: selectedOperator,
      description: null,
      aggregate,
    });
  };

  const openAggregate = () => {
    setOpenChangeStatus(true);
    setAggregate(true);
  };

  const cancelOrder = async (id: number) => {
    try {
      await orderRepository.cancelOrder({
        payload: {
          id,
          body: { description: "  " },
        },
      });
      handleNotification("سفارش با موفقیت لغو شد", "success");
    } catch (error) {
      handleError(error);
    }
  };

  const isSelected = (id: string) => selected.indexOf(id) !== -1;

  return (
    <div className={classes.root}>
      <EnhancedTableToolbar
        numSelected={selected.length}
        setOpenChangeStatus={setOpenChangeStatus}
        setOpenAggregate={openAggregate}
        selected={selected}
        data={props.data}
      />
      <Paper className={classes.paper}>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
          >
            <RonadTableHead
              onSort={handleRequestSort}
              order={order}
              orderBy={orderBy}
              headCells={headCells}
              rowCount={props.data.length}
              onSelectAll={handleSelectAllClick}
              numSelected={selected.length}
              action={true}
            />

            <TableBody>
              {props.data[0].warehouseType == "MULTI" && props.data.length == 1
                ? stableSort(
                    props.data[0].childOrders,
                    getComparator(order, orderBy)
                  ).map((row: any, index: number) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    const isItemSelected = isSelected(row.id);
                    let color = "";
                    let backgroundColor = "";
                    switch (true) {
                      case row.status === "CANCELLED" ||
                        row.status === "RETURNING" ||
                        row.vitrinStatus === "AWAITING_PAYMENT":
                        backgroundColor = "#fdd1cc";
                        color = "#611a15";
                        break;
                      case row.status === "UNLOADED" ||
                        row.status === "PACKAGED" ||
                        row.status === "BUNDLED" ||
                        row.status === "ASSIGNED":
                        backgroundColor = "#d1e8fa";
                        color = "#283c74";
                        break;
                      case row.status === "LOADED" ||
                        row.status === "DELIVERED":
                        backgroundColor = "#d7fcd7";
                        color = "#1e4659";
                        break;
                      case !row.exists && row.status === "ORDERED":
                        backgroundColor = "#f7d28b";
                        break;
                      case !row.exists && row.status === "SUPPLYING":
                        backgroundColor = "#FFFF8F";
                        break;
                    }

                    return (
                      <TableRow
                        key={index}
                        hover
                        // onClick={(event) => handleClick(event, row.id)}
                        // role="checkbox"
                        style={{ backgroundColor: backgroundColor }}
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        selected={isItemSelected}
                      >
                        <StyledTableCell>
                          <Can
                            role={authContext.user.role}
                            perform="orders:changeOrderStatus"
                            yes={() => (
                              <Checkbox
                                key={index}
                                onClick={(event) => handleClick(event, row.id)}
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            )}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ color: color }}
                          data-cy="row-id"
                        >
                          {row.id}
                          {row.parentId && `(${row.parentId})`}
                          {row.description && (
                            <HtmlTooltip title={row.description}>
                              <Icon path={mdiInformation} size={0.8} />
                            </HtmlTooltip>
                          )}
                        </StyledTableCell>
                        <StyledTableCell
                          id={labelId}
                          scope="row"
                          align="center"
                          style={{ color: color }}
                        >
                          {row.partnerName}
                        </StyledTableCell>
                        <StyledTableCell
                          id={labelId}
                          scope="row"
                          align="center"
                          style={{ color: color }}
                        >
                          {row.customerName}
                        </StyledTableCell>
                        <StyledTableCell
                          id={labelId}
                          scope="row"
                          align="center"
                          style={{ color: color }}
                        >
                          {row.customerCity}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ color: color }}
                        >
                          <span>
                            {jMoment(row.deliveryDate, "YYYY/M/D")
                              .locale("fa")
                              .format("jYY/jMM/jDD")}
                          </span>
                          &nbsp; &nbsp;- &nbsp; &nbsp;
                          <span>
                            {`${jMoment(row.deliveryStartTime, "HH:mm:ss")
                              .locale("fa")
                              .format("HH")}
                        `}
                            {`تا ${jMoment(row.deliveryEndTime, "HH:mm:ss")
                              .locale("fa")
                              .format("HH")}`}
                          </span>
                        </StyledTableCell>
                        <StyledTableCell
                          id={labelId}
                          scope="row"
                          align="center"
                        >
                          {showDeliveryType(row.deliveryType)}
                          {row.deliveryLocationType === "IN_RONAD"
                            ? "درب انبار"
                            : `(${showOrderTplType(
                                row.deliveryType,
                                row.orderTPLType
                              )})`}
                        </StyledTableCell>
                        <Can
                          role={authContext.user.role}
                          perform="orders:tracking-code"
                          yes={() => (
                            <StyledTableCell
                              id={labelId}
                              scope="row"
                              align="center"
                            >
                              {row.trackingCode}
                            </StyledTableCell>
                          )}
                        />
                        <StyledTableCell
                          align="center"
                          style={{ color: color }}
                        >
                          <StyledTableCell align="center">
                            {translate(row.paymentType, "cod")}
                          </StyledTableCell>
                          <Can
                            role={authContext.user.role}
                            perform="orders:changeOrderStatus"
                            yes={() => (
                              <FormControl style={{ width: "100%" }}>
                                <Icon
                                  path={mdiPencilOutline}
                                  size={1}
                                  className={classes.changStatusIcon}
                                />
                                <Select
                                  className={classes.changStatusBox}
                                  fullWidth
                                  name={`status${index}`}
                                  multiple
                                  id={row.rubikaId}
                                  value={[{}]}
                                  IconComponent={() => null}
                                  renderValue={() => (
                                    <span className={classes.renderValue}>
                                      {translate(row.status, "order")}
                                    </span>
                                  )}
                                >
                                  <RadioGroup
                                    className={classes.radioGroup}
                                    aria-label={`status${index}`}
                                    name={`status${index}`}
                                    value={"item"}
                                    onChange={(
                                      e: React.ChangeEvent<{ value: unknown }>
                                    ) =>
                                      props.handleOpenConfirmUpdateState({
                                        id: row.id,
                                        body: `${e.target.value}`,
                                      })
                                    }
                                  >
                                    {rulesOrderStatus[row.status]?.map(
                                      (item: any, index: number) => (
                                        <FormControlLabel
                                          className={classes.radioGroupItem}
                                          key={index}
                                          checked={row.status === item}
                                          value={item}
                                          disabled={
                                            rulesAdminChangeOrderStatus[
                                              authContext.user.role
                                            ].indexOf(item) === -1
                                          }
                                          control={<Radio />}
                                          label={translate(item, "order")}
                                        />
                                      )
                                    )}
                                  </RadioGroup>
                                </Select>
                              </FormControl>
                            )}
                            no={() => {
                              return (
                                <span>{translate(row.status, "order")}</span>
                              );
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <div>
                            {![
                              "DELIVERED",
                              "DELIVERING_TO_POST",
                              "RETURNED_TO_WAREHOUSE",
                            ].includes(row.status) && (
                              <IconButton onClick={() => cancelOrder(row.id)}>
                                <RonadIcons
                                  name="x-close"
                                  color="error"
                                  size="22px"
                                />
                              </IconButton>
                            )}
                            <Link to={`/orders/${row.id}`}>
                              <IconButton
                                aria-label="details"
                                size="small"
                                title="جزئیات سفارش"
                                data-cy="details"
                              >
                                <Icon
                                  path={mdiFileDocumentOutline}
                                  size={1}
                                  color={theme.palette.green.main}
                                />
                              </IconButton>
                            </Link>
                            <Can
                              role={authContext.user.role}
                              perform="orders:byBundle"
                              yes={() =>
                                row.status !== "ORDERED" && row.status ? (
                                  <Link to={`/bundles/${row.bundleId}`}>
                                    <IconButton
                                      aria-label="bundle"
                                      size="small"
                                      title="نمایش سفارش در بسته "
                                      color="secondary"
                                    >
                                      <Icon
                                        path={mdiPackageVariantClosed}
                                        size={1}
                                        color={theme.palette.blue.main}
                                      />
                                    </IconButton>
                                  </Link>
                                ) : (
                                  <IconButton
                                    aria-label="bundle"
                                    size="small"
                                    title="بسته‌بندی نشده"
                                    disabled
                                    color="default"
                                    style={{ pointerEvents: "fill" }}
                                  >
                                    <Icon
                                      path={mdiPackageVariantClosed}
                                      size={1}
                                    />
                                  </IconButton>
                                )
                              }
                            />
                            {/* <Can
                                role={authContext.user.role}
                                perform="orders:history"
                                yes={() => (
                                  <Link to={`/orders/${row.id}/allLogs`}>
                                    <IconButton
                                      size="small"
                                      title="تاریخچه سفارش"
                                    >
                                      <Icon path={mdiHistory} size={1} />
                                    </IconButton>
                                  </Link>
                                )}
                              /> */}
                            <Can
                              role={authContext.user.role}
                              perform="order:assign"
                              yes={() => (
                                <Link to={`/assign-order/${row.id}`}>
                                  <IconButton size="small" title="اختصاص سفارش">
                                    <Icon
                                      color="#b297a7"
                                      path={mdiAccountArrowLeftOutline}
                                      size={1}
                                    />
                                  </IconButton>
                                </Link>
                              )}
                            />
                            <Can
                              role={authContext.user.role}
                              perform="orders:cancelOrders"
                              yes={() => (
                                <IconButton
                                  aria-label="cancele"
                                  title={
                                    row.status === "CANCELLED"
                                      ? "لغو شده"
                                      : "لغو سفارش"
                                  }
                                  size="small"
                                  style={{ pointerEvents: "fill" }}
                                  disabled={row.status === "CANCELLED"}
                                  onClick={() => handleClickOpen(row.id)}
                                >
                                  <Icon
                                    path={mdiClose}
                                    size={1}
                                    color={
                                      row.status !== "CANCELLED"
                                        ? theme.palette.error.main
                                        : theme.palette.gray.main
                                    }
                                  />
                                </IconButton>
                              )}
                            />
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    );
                  })
                : stableSort(props.data, getComparator(order, orderBy)).map(
                    (row: any, index: number) => {
                      const labelId = `enhanced-table-checkbox-${index}`;
                      const isItemSelected = isSelected(row.id);
                      let color = "";
                      let backgroundColor = "";
                      switch (true) {
                        case row.status === "CANCELLED" ||
                          row.status === "RETURNING" ||
                          row.vitrinStatus === "AWAITING_PAYMENT":
                          backgroundColor = "#fdd1cc";
                          color = "#611a15";
                          break;
                        case row.status === "UNLOADED" ||
                          row.status === "PACKAGED" ||
                          row.status === "BUNDLED" ||
                          row.status === "ASSIGNED":
                          backgroundColor = "#d1e8fa";
                          color = "#283c74";
                          break;
                        case row.status === "LOADED" ||
                          row.status === "DELIVERED":
                          backgroundColor = "#d7fcd7";
                          color = "#1e4659";
                          break;
                        case !row.exists && row.status === "ORDERED":
                          backgroundColor = "#f7d28b";
                          break;
                        case !row.exists && row.status === "SUPPLYING":
                          backgroundColor = "#FFFF8F";
                      }

                      return (
                        <TableRow
                          key={index}
                          hover
                          role="checkbox"
                          style={{ backgroundColor: backgroundColor }}
                        >
                          <StyledTableCell padding="checkbox">
                            <Can
                              role={authContext.user.role}
                              perform="orders:changeOrderStatus"
                              yes={() => (
                                <Checkbox
                                  key={index}
                                  onClick={(event) =>
                                    handleClick(event, row.id)
                                  }
                                  checked={isItemSelected}
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              )}
                            />
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            style={{ color: color }}
                            data-cy="row-id"
                          >
                            {row.parentId ? `(${row.parentId})` : row.id}
                            {row.description && (
                              <HtmlTooltip title={row.description}>
                                <Icon path={mdiInformation} size={0.8} />
                              </HtmlTooltip>
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            id={labelId}
                            scope="row"
                            align="center"
                            style={{ color: color }}
                          >
                            {row.partnerName}
                          </StyledTableCell>
                          <StyledTableCell
                            id={labelId}
                            scope="row"
                            align="center"
                            style={{ color: color }}
                          >
                            {row.customerName}
                          </StyledTableCell>
                          <StyledTableCell
                            id={labelId}
                            scope="row"
                            align="center"
                            style={{ color: color }}
                          >
                            {row.customerCity}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            style={{ color: color }}
                          >
                            <span>
                              {jMoment(row.deliveryDate, "YYYY/M/D")
                                .locale("fa")
                                .format("jMM/jDD")}
                            </span>
                            &nbsp; &nbsp;- &nbsp; &nbsp;
                            <span>
                              {`${jMoment(row.deliveryStartTime, "HH:mm:ss")
                                .locale("fa")
                                .format("HH")}
                        `}
                              {`تا ${jMoment(row.deliveryEndTime, "HH:mm:ss")
                                .locale("fa")
                                .format("HH")}`}
                            </span>
                          </StyledTableCell>
                          <StyledTableCell
                            id={labelId}
                            scope="row"
                            align="center"
                          >
                            {showDeliveryType(row.deliveryType)}
                            &nbsp;
                            {row.deliveryLocationType === "IN_RONAD"
                              ? "(درب انبار)"
                              : `(${showOrderTplType(
                                  row.deliveryType,
                                  row.orderTPLType
                                )})`}
                          </StyledTableCell>
                          <Can
                            role={authContext.user.role}
                            perform="orders:tracking-code"
                            yes={() => (
                              <StyledTableCell
                                id={labelId}
                                scope="row"
                                align="center"
                              >
                                {row.trackingCode}
                              </StyledTableCell>
                            )}
                          />
                          <StyledTableCell align="center">
                            {
                              row.fulfillmentLineId
                                ? row.fulfillmentLineName
                                : "ندارد"
                              /*translate(row.paymentType, 'cod')*/
                            }
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {`${row.itemsCount} ( ${row.inventoryItemsCount} )`}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <span>
                              {row.deadlineProcessDate &&
                                `${row.deadlineProcessTime} - ${jMoment(
                                  row.deadlineProcessDate,
                                  "YYYY/MM/DD"
                                )
                                  .locale("fa")
                                  .format("jMM/jDD")}`}
                            </span>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            style={{ color: color }}
                          >
                            <Can
                              role={authContext.user.role}
                              perform="orders:changeOrderStatus"
                              yes={() => (
                                <FormControl style={{ width: "100%" }}>
                                  <Icon
                                    path={mdiPencilOutline}
                                    size={1}
                                    className={classes.changStatusIcon}
                                  />
                                  <Select
                                    className={classes.changStatusBox}
                                    fullWidth
                                    name={`status${index}`}
                                    multiple
                                    id={row.rubikaId}
                                    value={[{}]}
                                    IconComponent={() => null}
                                    renderValue={() => (
                                      <span className={classes.renderValue}>
                                        {translate(row.status, "order")}
                                      </span>
                                    )}
                                  >
                                    <RadioGroup
                                      className={classes.radioGroup}
                                      aria-label={`status${index}`}
                                      name={`status${index}`}
                                      value={"item"}
                                      onChange={(
                                        e: React.ChangeEvent<{ value: unknown }>
                                      ) =>
                                        props.handleOpenConfirmUpdateState({
                                          id: row.id,
                                          body: `${e.target.value}`,
                                        })
                                      }
                                    >
                                      {rulesOrderStatus[row.status]?.map(
                                        (item: any, index: number) => (
                                          <FormControlLabel
                                            className={classes.radioGroupItem}
                                            key={index}
                                            checked={row.status === item}
                                            value={item}
                                            disabled={
                                              rulesAdminChangeOrderStatus[
                                                authContext.user.role
                                              ].indexOf(item) === -1
                                            }
                                            control={<Radio />}
                                            label={translate(item, "order")}
                                          />
                                        )
                                      )}
                                    </RadioGroup>
                                  </Select>
                                </FormControl>
                              )}
                              no={() => {
                                return (
                                  <span>{translate(row.status, "order")}</span>
                                );
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <div>
                              <Link to={`/orders/${row.id}`}>
                                <IconButton
                                  aria-label="details"
                                  size="small"
                                  title="جزئیات سفارش"
                                  data-cy="details"
                                >
                                  <Icon
                                    path={mdiFileDocumentOutline}
                                    size={1}
                                    color={theme.palette.green.main}
                                  />
                                </IconButton>
                              </Link>
                              <Can
                                role={authContext.user.role}
                                perform="orders:byBundle"
                                yes={() =>
                                  row.status !== "ORDERED" && row.status ? (
                                    <Link to={`/bundles/${row.bundleId}`}>
                                      <IconButton
                                        aria-label="bundle"
                                        size="small"
                                        title="نمایش سفارش در بسته "
                                        color="secondary"
                                      >
                                        <Icon
                                          path={mdiPackageVariantClosed}
                                          size={1}
                                          color={theme.palette.blue.main}
                                        />
                                      </IconButton>
                                    </Link>
                                  ) : (
                                    <IconButton
                                      aria-label="bundle"
                                      size="small"
                                      title="بسته‌بندی نشده"
                                      disabled
                                      color="default"
                                      style={{ pointerEvents: "fill" }}
                                    >
                                      <Icon
                                        path={mdiPackageVariantClosed}
                                        size={1}
                                      />
                                    </IconButton>
                                  )
                                }
                              />
                              {/* <Can
                                role={authContext.user.role}
                                perform="orders:history"
                                yes={() => (
                                  <Link to={`/orders/${row.id}/allLogs`}>
                                    <IconButton
                                      size="small"
                                      title="تاریخچه سفارش"
                                    >
                                      <Icon path={mdiHistory} size={1} />
                                    </IconButton>
                                  </Link>
                                )}
                              /> */}
                              <Can
                                role={authContext.user.role}
                                perform="order:assign"
                                yes={() => (
                                  <Link to={`/assign-order/${row.id}`}>
                                    <IconButton
                                      size="small"
                                      title="اختصاص سفارش"
                                    >
                                      <Icon
                                        color="#b297a7"
                                        path={mdiAccountArrowLeftOutline}
                                        size={1}
                                      />
                                    </IconButton>
                                  </Link>
                                )}
                              />
                              <Can
                                role={authContext.user.role}
                                perform="orders:cancelOrders"
                                yes={() => (
                                  <IconButton
                                    aria-label="cancele"
                                    title={
                                      row.status === "CANCELLED"
                                        ? "لغو شده"
                                        : "لغو سفارش"
                                    }
                                    size="small"
                                    style={{ pointerEvents: "fill" }}
                                    disabled={row.status === "CANCELLED"}
                                    onClick={() => handleClickOpen(row.id)}
                                  >
                                    <Icon
                                      path={mdiClose}
                                      size={1}
                                      color={
                                        row.status !== "CANCELLED"
                                          ? theme.palette.error.main
                                          : theme.palette.gray.main
                                      }
                                    />
                                  </IconButton>
                                )}
                              />
                            </div>
                          </StyledTableCell>
                        </TableRow>
                      );
                    }
                  )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Dialog
        fullWidth
        open={openChangeStatus}
        onClose={() => setOpenChangeStatus(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>{"تغییر وضعیت سفارش به تخصیص داده شده"}</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">
              {"اپراتور مورد نظر را انتخاب کنید"}
            </FormLabel>
            <Grid
              container
              xs={12}
              style={{ marginTop: "20px", marginRight: 0, marginLeft: 0 }}
            >
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <List
                  onSelectOperator={handleSelectOperator}
                  selectedOperator={selectedOperator}
                  data={props.users}
                />
              )}
            </Grid>
          </FormControl>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenChangeStatus(false)}
            variant="outlined"
            color="primary"
          >
            {"انصراف"}
          </Button>
          <Button
            onClick={changeStatusOrder}
            color="primary"
            variant="contained"
            disabled={!selectedOperator}
          >
            {"تخصیص اپراتور"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
